import template from './modal.template.html';
import './modal.scss';

export default {
  template,
  transclude: {
    header: 'modalHeader',
    content: 'modalContent',
  },
};



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal.component.js